module.exports = __webpack_public_path__ + "img/data.c684e47e.jpg";